module.exports = __webpack_public_path__ + "static/img/image_recruit_08.2160d44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/join/image_recruit_08.png
// module id = en46
// module chunks = 10